import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataService, UtilsService } from '../../services';
import { PatientRegisterService } from 'src/app/screens/patient-registration/services/patient-register.service';

@Component({
  selector: 'app-sticky-note-section',
  templateUrl: './sticky-note-section.component.html',
  styleUrls: ['./sticky-note-section.component.scss']
})
export class StickyNoteSectionComponent implements OnInit, OnChanges {
  @Input() patientRegistration: any;
  @Input() sessionType: string;
  @Input() roleType: string;
  @Input() practitionerId: number;
  @Input() isDashboard: boolean;
  notes = [];
  allNotes = [];
  selectedNote: any;
  isCurrentUser: boolean = false;

  constructor(
    private utilService: UtilsService,
    private dataService: DataService,
    private patientRegisterService: PatientRegisterService,
  ) { }

  ngOnInit(): void {
    const roleId = this.dataService.userDetails.role_id;
    if (this.practitionerId != null && this.isDashboard) {
      this.isCurrentUser = roleId === this.practitionerId;
    } else {
      this.isCurrentUser = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['patientRegistration'] && changes['patientRegistration'].currentValue) {
      this.getSessionNotes(this.sessionType);
    }
  }

  isPractitioner(): boolean {
    const allowedRoleIds = [13, 15, 16];
    const userRoleId = this.dataService?.userDetails?.role_id;
    return allowedRoleIds.includes(userRoleId);
  }

  updatePosition(event: { index: number, top: number, left: number }) {
    this.notes[event.index].top = event.top;
    this.notes[event.index].left = event.left;
  }

  deleteNote(index: number) {
    this.notes.splice(index, 1);
  }

  viewNote(note: any) {
    this.selectedNote = note;
    this.notes.push({ content: note?.sessionNotes, top: 148, left: 138, noteType: note?.noteType });
  }

  getSessionNotes(sessionType: string) {
    const payload = {
      // appointmentId: this.patientRegistration.patient_appointment_id,
      patientId: this.patientRegistration.patient_id,
      isDashboard: this.isDashboard ? false : true
    }

    // if(sessionType === 'RPP') {
    //   payload['consultationId'] = this.patientRegistration.consultation_id
    // }

    // if(this.practitionerId) {
    //   payload['roleId'] = this.practitionerId;
    // }

    this.patientRegisterService.getSessionNotes(payload).subscribe({
      next: (res: any) => {
         if (this.roleType == null) {
          this.allNotes = res.data;
        } else {
          this.allNotes = res.data.filter(res => res.roleType === this.roleType);
        }

      },
      error: err => {
        this.utilService.showErrorToast(err.message || 'Error While fetching Notes');
      }
    })
  }

  handleNoteSubmit(event: { index: number, content: string }) {
    this.notes[event.index].content = event.content;
    const plainText = this.notes[event.index].content?.replace(/<[^>]*>/g, '').trim();

    if (!plainText) {
      this.utilService.showInfoToast("Empty Note can't be saved.");
      return;
    }

    const payload = {
      patientId: this.patientRegistration?.patient_id,
      patientRefId: this.patientRegistration?.patient_ref_id,
      appointmentId: this.patientRegistration?.patient_appointment_id,
      sessionNotes: this.notes[event.index].content,
      sessionType: this.sessionType,
      noteType: this.notes[event.index].noteType,
    };

    if(this.sessionType === 'RPP') {
      payload['consultationId'] = this.patientRegistration.consultation_id
      payload['patientRppId'] = this.patientRegistration?.patient_rpp_id
    }

    if (this.selectedNote?.sessionNoteId) {
      payload['sessionNoteId'] = this.selectedNote.sessionNoteId;
      this.saveOrUpdateNote(this.patientRegisterService.editSessionNote(payload), this.notes[event.index], 'updated');
    } else {
      this.saveOrUpdateNote(this.patientRegisterService.saveSessionNotes(payload), this.notes[event.index], 'saved');
    }
  }

  private saveOrUpdateNote(obs$: any, index: number, action: 'saved' | 'updated') {
    obs$.subscribe({
      next: (res: any) => {
        if (res) {
          this.notes.splice(index, 1);
          this.getSessionNotes(this.sessionType);
          this.utilService.showSuccessToast(res.message || `Session Note ${action} successfully`);
        }
      },
      error: err => {
        this.utilService.showErrorToast(err.message || `Error while ${action === 'saved' ? 'saving' : 'updating'} note`);
      }
    });
  }

  onInactive(note: any) {
    const payload = {
      isDeleted: true,
      sessionNoteId: note.sessionNoteId
    };

    this.patientRegisterService.editSessionNote(payload).subscribe({
      next: (res) => {
        if (res) {
          this.utilService.showSuccessToast("Note Deleted Successfully");
          this.getSessionNotes(this.sessionType);
        }
      },
      error: (err) => {
        this.utilService.showErrorToast(err.message || 'Error While deleting Note');
      }
    });
  }

  addPreNote(noteType: string) {
    this.selectedNote = '';
    this.notes.push({ content: '', top: 148, left: 138, noteType: noteType });
  }

  addPostNote(noteType: string) {
    this.selectedNote = '';
    this.notes.push({ content: '', top: 148, left: 138, noteType: noteType });
  }

}
